var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('WebIMPage'),_c('audio',{staticClass:"audio-sound",staticStyle:{"display":"none"},attrs:{"id":"ringAudio","src":"https://bqq.gtimg.com/CDN/source/audio/ring.mp3","muted":"","loop":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }